<template>
  <div class="wrapper">
    <div class="greeting-message">
      <div class="greeting-message-avatar">
        <img
          data-testid="manager-avatar"
          v-if="managerAvatar"
          :src="managerAvatar"
          alt=""
        />
      </div>
      <div class="greeting-message-bubble">
        <strong>
          {{ lastName }}
          {{ firstName }} :
        </strong>
        <br />
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { getOptimizedImageUrl } from "@/utils/image";

@Component
export default class GreetingMessage extends Vue {
  @Prop({
    type: String,
    required: true
  })
  personImage!: string;

  @Prop({
    type: String,
    required: true
  })
  lastName!: string;

  @Prop({
    type: String,
    required: true
  })
  firstName!: string;

  @Prop({
    type: String,
    required: true
  })
  message!: string;

  get managerAvatar() {
    /* 小さすぎるとぼやけるので240px */
    return getOptimizedImageUrl(this.personImage, 240, 240);
  }
}
</script>

<style lang="scss" scoped>
.greeting-message {
  display: flex;

  &-avatar {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    overflow: hidden;
    border: 1px solid $gray-03;
    border-radius: 50%;

    img {
      width: 48px;
      height: 48px;
      object-fit: cover;
    }
  }

  &-bubble {
    position: relative;
    flex-grow: 1;
    padding: 8px;
    margin-left: 16px;
    font-size: 14px;
    background-color: $gray-01;
    border: 1px solid $gray-03;
    border-radius: 8px;

    &::after,
    &::before {
      position: absolute;
      top: 20px;
      right: 100%;
      width: 0;
      height: 0;
      content: "";
      border: solid transparent;
    }

    &::after {
      margin-top: -8px;
      border-color: rgba($gray-03, 0);
      border-top-width: 8px;
      border-right-color: $gray-01;
      border-right-width: 8px;
      border-bottom-width: 8px;
      border-left-width: 8px;
    }

    &::before {
      margin-top: -9px;
      margin-right: 1px;
      border-color: rgba($gray-01, 0);
      border-top-width: 9px;
      border-right-color: $gray-03;
      border-right-width: 9px;
      border-bottom-width: 9px;
      border-left-width: 9px;
    }

    strong {
      font-weight: 500;
    }
  }
}

.wrapper {
  position: relative;
}
</style>
